// extracted by mini-css-extract-plugin
export default {"wrapperList":"Support_wrapperList__Vtlru","title":"Support_title__MbiaE","list":"Support_list__XLk11","item":"Support_item__4Jjgz","link":"Support_link__iWqFP"};